type SystemBackOverlayHandler = () => void;

type SystemBackOverlayEntry = {
	id: symbol;
	handler: SystemBackOverlayHandler;
};

const overlayStack: SystemBackOverlayEntry[] = [];

export const registerSystemBackOverlay = (handler: SystemBackOverlayHandler) => {
	const id = Symbol("system-back-overlay");
	overlayStack.push({ id, handler });

	return () => {
		const index = overlayStack.findIndex(entry => entry.id === id);
		if (index >= 0) overlayStack.splice(index, 1);
	};
};

export const handleRegisteredOverlaySystemBack = () => {
	const entry = overlayStack[overlayStack.length - 1];
	if (!entry) return false;

	entry.handler();
	return true;
};

export const resetSystemBackOverlaysForTests = () => {
	overlayStack.splice(0, overlayStack.length);
};
